export default {
  login: {
    noSession: 'Your session has expired, please log in again.',
  },
  chatbot: {
    title: 'Help centre',
    you: 'You',
    messages: {
      welcome: 'Hello {{ name }}! Welcome to the help centre. I am an AI assistant available at any time to help you use SKEZI.',
      askQuestionOrConsultFaq: 'You can ask me a question, or simply have a look at the FAQs:',
    },
  },
  error: {
    UNKNOWN_ERROR: 'Unknown error. If the problem persists, please contact support',
    INVALID_INPUTS: 'The data sent in the form is invalid',
    EMAIL_ALREADY_USED: 'Email already used',
    INVALID_CREDENTIALS_OR_NOT_CONFIRMED:
      'Your email or password is incorrect. If an account was previously created, an email will be sent.',
    INVALID_CODE: 'Invalid code',
    INVALID_TOKEN: 'The Token supplied is invalid',
    INVALID_PASSWORD: 'Password invalid',
    INVALID_OLD_PASSWORD: 'Current password is invalid',
    INVALID_AUTHORIZATION_TOKEN: 'The authorisation token is invalid',
    APPLICATION_NOT_FOUND: 'Application not found',
    INVALID_SECRET: 'Invalid secret',
    NICKNAME_ALEREADY_USED: 'Identifier already in use',
    NO_VALID_SESSION: 'Not logged or session has expired',
    DOUBLE_AUTH_NOT_ENABLE: 'Double authentication is not enabled on your account. Please log in again.',
    ALREADY_AUTHENTICATED: 'You are already authenticated',
    OTP_COOLDOWN: 'Please wait a few seconds before requesting a new code',
  },
  placeholder: {
    askQuestion: 'Ask your question',
  },
  button: {
    viewFAQ: 'View the FAQ',
    contactSupport: 'Contact support',
    contact: 'Contact',
    screenshot: 'Take screenshot',
    cancel: 'Cancel',
    send: 'Send',
  },
  input: {
    email: 'Email',
    nickname: 'How should we call you?',
    description: 'Description',
    attachment: 'Attachment',
  },
  contact: {
    title: 'Contact',
    subtitle: 'Feel free to contact us!',
    success: 'Thank you for contacting us! Our team will do its utmost to respond to your request within 24 to 48 working hours.',
    screenshotDescription: 'Add a screenshot of your window so that we can best respond to your problem.',
  },
};
